// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Dots = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill}
      stroke={stroke}
      strokeWidth="2px"
    >
      <circle cx="24" cy="24" r="4" />
      <circle cx="42" cy="24" r="4" />
      <circle cx="6" cy="24" r="4" />
    </svg>
  );
};
